/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Fact_Linked_OffersInputs */

const cs_ebr_fact_linked_offers = /** @type {(inputs: Ebr_Fact_Linked_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojené nabídky v CRM`)
};

const en_ebr_fact_linked_offers = /** @type {(inputs: Ebr_Fact_Linked_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked offers in CRM`)
};

/**
* | output |
* | --- |
* | "Linked offers in CRM" |
*
* @param {Ebr_Fact_Linked_OffersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_fact_linked_offers = /** @type {((inputs?: Ebr_Fact_Linked_OffersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Fact_Linked_OffersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_fact_linked_offers(inputs)
	return cs_ebr_fact_linked_offers(inputs)
});